<script>
    import { navigate } from 'svelte-routing'
    import date from 'date-and-time'
    import { Functions } from '../../config/firebase'
    import { currentUser } from '../../stores/current_user'

    import { Projects } from '../../middleware/database/projects'

    import Form from './form.svelte'
    import { Spinner } from 'sveltestrap'

    let saving = false

    const project = {
        name: ''
    }

    function saveHandler(event) {
        saving = true
        let project = event.detail

        Projects.add(project)
        .then(ref => {
            saving = false
            navigate('/projects')
        })
        .catch(err => {
                alert('Could not create new project.')
                console.log('Save Project:', err)
                saving = false
        })
    }
</script>

{#if !saving}
<Form pageTitle="Create new project" {project} on:submit={saveHandler} />
{:else}
<Spinner size="lg" color="dark" type="grow" />
{/if}